import { createContext, useContext, useEffect, useState, useCallback } from "react";

const LangContext = createContext(null);
const STORAGE_KEY = "drago_lang";

const dict = {
  it: {
    // navbar
    nav_menu: "Menu",
    nav_categorie: "Categorie",
    nav_prenota: "Prenota",
    nav_chi_siamo: "Chi Siamo",
    nav_dove_siamo: "Dove Siamo",
    nav_ordina: "Ordina",
    nav_cart_open: "Apri carrello",
    // hero
    hero_overline: "Drago Ramen · Catania",
    hero_title_1: "La vera cucina",
    hero_title_asia: "asiatica",
    hero_title_at: "a",
    hero_subtitle: "Ricette originali cinesi, ramen artigianale e piatti autentici. Un'esperienza gastronomica costruita con ingredienti scelti e mani esperte.",
    hero_cta_book: "Prenota un tavolo",
    hero_cta_menu: "Guarda il menu",
    hero_stat_categorie: "Categorie",
    hero_stat_brodo: "Brodo",
    hero_stat_autentico: "Autentico",
    // dishes section (categorie)
    dishes_overline: "Le Categorie",
    dishes_title_1: "Sei mondi, un solo",
    dishes_title_end: "tavolo",
    dishes_subtitle: "Tocca una categoria per esplorare i piatti e ordinare direttamente dal menu.",
    // menu section
    menu_overline: "Il Menu completo",
    menu_title_1: "Ordina il tuo",
    menu_title_end: "viaggio",
    menu_subtitle: "Asporto, al tavolo, o consegna con Just Eat e Glovo.",
    menu_allergens_title: "Legenda allergeni (Reg. UE 1169/2011)",
    menu_allergens_ask: "Per informazioni su allergeni e intolleranze chiedere al personale.",
    menu_allergens_label: "Allergeni",
    menu_contains: "Contiene:",
    menu_add_aria: "Aggiungi",
    // booking
    booking_overline: "Prenotazione",
    booking_title: "Prenota il tuo tavolo.",
    booking_intro: "Compila i dati e invia la richiesta. Il ristorante ti confermerà a stretto giro via WhatsApp o telefono.",
    booking_how_title: "Come funziona",
    booking_how_body: "La tua prenotazione è in attesa di conferma fino alla risposta del ristorante. Per modifiche o annullamenti, usa il pulsante \"Gestisci prenotazione\" o contattaci su WhatsApp.",
    booking_slot_note: "Slot dalle 11:30 alle 23:30, ogni 30 minuti.",
    booking_code_note: "Salva il codice prenotazione: ti servirà per modificarla o annullarla.",
    booking_manage: "Gestisci una prenotazione",
    booking_name: "Nome",
    booking_surname: "Cognome",
    booking_phone: "Telefono",
    booking_email: "Email",
    booking_date: "Data",
    booking_time: "Orario",
    booking_people: "Persone",
    booking_notes: "Richieste particolari",
    booking_notes_ph: "Allergie, tavolo tranquillo, occasione speciale...",
    booking_submit: "Invia richiesta di prenotazione",
    booking_submitting: "Invio richiesta...",
    booking_submit_hint: "Al termine si apre WhatsApp con un messaggio precompilato per il ristorante.",
    booking_success_title: "Richiesta ricevuta!",
    booking_success_status: "in attesa di conferma",
    booking_success_body: ". Il ristorante ti contatterà a breve al numero fornito.",
    booking_code: "Codice",
    booking_status: "Stato",
    booking_status_pending: "In attesa",
    booking_open_wa: "Apri WhatsApp",
    booking_new: "Nuova prenotazione",
    booking_select_date: "Seleziona data",
    booking_select_slot: "Seleziona prima una data per vedere gli orari disponibili.",
    booking_loading_slots: "Carico orari...",
    // manage dialog
    manage_title: "Gestisci prenotazione",
    manage_your_title: "La tua prenotazione",
    manage_hint: "Inserisci il codice prenotazione ricevuto e il numero di telefono con cui hai prenotato.",
    manage_code: "Codice",
    manage_phone: "Telefono",
    manage_search: "Cerca prenotazione",
    manage_searching: "Cerco...",
    manage_wa_hint: "Preferisci parlare con noi?",
    manage_wa_link: "Scrivici su WhatsApp",
    manage_modify_wa: "Chiedi modifica via WhatsApp",
    manage_cancel: "Annulla prenotazione",
    manage_cancelling: "Annullo...",
    manage_reset: "← Cerca un'altra prenotazione",
    // status labels
    status_confirmed: "Confermata",
    status_pending: "In attesa di conferma",
    status_cancelled: "Annullata",
    // cart
    cart_title: "Il tuo ordine",
    cart_sent_title: "Ordine inviato",
    cart_empty: "Il carrello è vuoto.",
    cart_back_to_menu: "← Torna al menu",
    cart_delivery_title: "Consegna a domicilio",
    cart_delivery_hint: "Ordina la consegna con i nostri partner ufficiali:",
    cart_mode: "Modalità",
    cart_takeaway: "Asporto",
    cart_dinein: "Al tavolo",
    cart_table_number: "Numero tavolo (opzionale)",
    cart_table_ph: "es. 5 — o lascia vuoto se non lo conosci",
    cart_name: "Nome",
    cart_phone: "Telefono",
    cart_notes: "Note (opzionale)",
    cart_notes_ph: "Allergie, richieste particolari...",
    cart_status_info: "L'ordine è in attesa di conferma dal ristorante via WhatsApp. Per consegna a domicilio usa Just Eat o Glovo qui sotto.",
    cart_send: "Invia ordine via WhatsApp",
    cart_sending: "Invio...",
    cart_clear: "Svuota carrello",
    cart_total: "Totale",
    cart_success_title: "Ordine ricevuto!",
    cart_success_body: "In attesa di conferma dal ristorante via WhatsApp. Ti contatteranno al più presto.",
    cart_new_order: "Nuovo ordine",
    // about
    about_overline: "Chi Siamo",
    about_title_1: "La cucina asiatica come",
    about_title_end: "arte",
    about_body_1: "Ristorante Drago Ramen porta a Catania la vera cucina asiatica, senza compromessi. La nostra cucina è guidata da chef cinesi con oltre 30 anni di esperienza, che ogni giorno lavorano gli impasti, i brodi e le salse come si è sempre fatto — con cura, amore e tradizione.",
    about_body_2: "Ramen artigianale, ravioli e baozi fatti a mano ogni singolo giorno, wok tradizionale cinese e specialità coreane. Il brodo sobbolle per ore, il kimchi fermenta lentamente, i gyoza vengono chiusi uno per uno.",
    about_body_3: "Non è veloce, non è semplice — ma è vero. È l'unica cucina che sappiamo fare, ed è quella che vogliamo condividere con te.",
    // cancel via WhatsApp
    manage_cancel_wa: "Annulla via WhatsApp",
    footer_developed: "Made with 龍 in Catania",
    // location
    loc_overline: "Dove Siamo",
    loc_title: "Ti aspettiamo nel cuore di Catania.",
    loc_address: "Indirizzo",
    loc_cell: "Cellulare",
    loc_wa: "Tel / WhatsApp",
    loc_hours: "Orari",
    loc_hours_value: "Tutti i giorni · 11:00 – 24:00",
    loc_directions: "Indicazioni Google Maps",
    // footer
    footer_intro: "La vera cucina asiatica nel cuore di Catania. Ramen artigianale, wok tradizionale, ravioli fatti a mano. Ordina online o prenota il tuo tavolo.",
    footer_hours: "Orari",
    footer_hours_all: "Tutti i giorni",
    footer_contacts: "Contatti",
    footer_delivery: "Consegna a domicilio",
    footer_rights: "Tutti i diritti riservati.",
  },
  en: {
    // navbar
    nav_menu: "Menu",
    nav_categorie: "Categories",
    nav_prenota: "Book",
    nav_chi_siamo: "About",
    nav_dove_siamo: "Find us",
    nav_ordina: "Order",
    nav_cart_open: "Open cart",
    // hero
    hero_overline: "Drago Ramen · Catania",
    hero_title_1: "True",
    hero_title_asia: "Asian",
    hero_title_at: "cuisine in",
    hero_subtitle: "Original Chinese recipes, handcrafted ramen and authentic dishes. A gastronomic journey built with chosen ingredients and expert hands.",
    hero_cta_book: "Book a table",
    hero_cta_menu: "See the menu",
    hero_stat_categorie: "Categories",
    hero_stat_brodo: "Broth",
    hero_stat_autentico: "Authentic",
    // dishes
    dishes_overline: "Categories",
    dishes_title_1: "Six worlds, one",
    dishes_title_end: "table",
    dishes_subtitle: "Tap a category to explore the dishes and order directly from the menu.",
    // menu
    menu_overline: "Full Menu",
    menu_title_1: "Order your",
    menu_title_end: "journey",
    menu_subtitle: "Takeaway, dine-in, or home delivery via Just Eat and Glovo.",
    menu_allergens_title: "Allergens legend (EU Reg. 1169/2011)",
    menu_allergens_ask: "For allergen and intolerance info please ask the staff.",
    menu_allergens_label: "Allergens",
    menu_contains: "Contains:",
    menu_add_aria: "Add",
    // booking
    booking_overline: "Reservation",
    booking_title: "Book your table.",
    booking_intro: "Fill in your details and send the request. The restaurant will confirm shortly via WhatsApp or phone.",
    booking_how_title: "How it works",
    booking_how_body: "Your reservation is pending until the restaurant replies. For changes or cancellations, use the \"Manage reservation\" button or WhatsApp us.",
    booking_slot_note: "Slots from 11:30 to 23:30, every 30 minutes.",
    booking_code_note: "Save your reservation code: you'll need it to modify or cancel.",
    booking_manage: "Manage a reservation",
    booking_name: "First name",
    booking_surname: "Last name",
    booking_phone: "Phone",
    booking_email: "Email",
    booking_date: "Date",
    booking_time: "Time",
    booking_people: "Guests",
    booking_notes: "Special requests",
    booking_notes_ph: "Allergies, quiet table, special occasion...",
    booking_submit: "Send reservation request",
    booking_submitting: "Sending...",
    booking_submit_hint: "WhatsApp will open with a prefilled message for the restaurant.",
    booking_success_title: "Request received!",
    booking_success_status: "pending confirmation",
    booking_success_body: ". The restaurant will contact you shortly at the number provided.",
    booking_code: "Code",
    booking_status: "Status",
    booking_status_pending: "Pending",
    booking_open_wa: "Open WhatsApp",
    booking_new: "New reservation",
    booking_select_date: "Select a date",
    booking_select_slot: "Pick a date to see available times.",
    booking_loading_slots: "Loading times...",
    // manage dialog
    manage_title: "Manage reservation",
    manage_your_title: "Your reservation",
    manage_hint: "Enter the reservation code you received and the phone number you used.",
    manage_code: "Code",
    manage_phone: "Phone",
    manage_search: "Find reservation",
    manage_searching: "Searching...",
    manage_wa_hint: "Rather talk to us?",
    manage_wa_link: "Message us on WhatsApp",
    manage_modify_wa: "Request change via WhatsApp",
    manage_cancel: "Cancel reservation",
    manage_cancelling: "Cancelling...",
    manage_reset: "← Search another reservation",
    // status
    status_confirmed: "Confirmed",
    status_pending: "Pending",
    status_cancelled: "Cancelled",
    // cart
    cart_title: "Your order",
    cart_sent_title: "Order sent",
    cart_empty: "Your cart is empty.",
    cart_back_to_menu: "← Back to menu",
    cart_delivery_title: "Home delivery",
    cart_delivery_hint: "Order home delivery with our official partners:",
    cart_mode: "Mode",
    cart_takeaway: "Takeaway",
    cart_dinein: "Dine-in",
    cart_table_number: "Table number (optional)",
    cart_table_ph: "e.g. 5 — or leave empty",
    cart_name: "Name",
    cart_phone: "Phone",
    cart_notes: "Notes (optional)",
    cart_notes_ph: "Allergies, special requests...",
    cart_status_info: "Order is pending confirmation via WhatsApp. For home delivery use Just Eat or Glovo below.",
    cart_send: "Send order via WhatsApp",
    cart_sending: "Sending...",
    cart_clear: "Empty cart",
    cart_total: "Total",
    cart_success_title: "Order received!",
    cart_success_body: "Pending confirmation from the restaurant via WhatsApp. They'll contact you shortly.",
    cart_new_order: "New order",
    // about
    about_overline: "About us",
    about_title_1: "Asian cuisine as",
    about_title_end: "art",
    about_body_1: "Ristorante Drago Ramen brings true Asian cuisine to Catania, no compromises. Our kitchen is led by Chinese chefs with over 30 years of experience, kneading, simmering and folding every day the way it has always been done — with care, love and tradition.",
    about_body_2: "Handcrafted ramen, dumplings and baozi folded by hand every single day, traditional Chinese wok and Korean specialties. The broth simmers for hours, the kimchi ferments slowly, gyoza are sealed one by one.",
    about_body_3: "It's not fast, it's not simple — but it's real. It's the only cuisine we know how to make, and the one we want to share with you.",
    // cancel via WhatsApp
    manage_cancel_wa: "Cancel via WhatsApp",
    footer_developed: "Made with 龍 in Catania",
    // location
    loc_overline: "Find us",
    loc_title: "We're waiting for you in the heart of Catania.",
    loc_address: "Address",
    loc_cell: "Mobile",
    loc_wa: "Phone / WhatsApp",
    loc_hours: "Hours",
    loc_hours_value: "Every day · 11:00 – 24:00",
    loc_directions: "Google Maps directions",
    // footer
    footer_intro: "True Asian cuisine in the heart of Catania. Handcrafted ramen, traditional wok, hand-folded dumplings. Order online or book your table.",
    footer_hours: "Hours",
    footer_hours_all: "Every day",
    footer_contacts: "Contacts",
    footer_delivery: "Home delivery",
    footer_rights: "All rights reserved.",
  },
};

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem(STORAGE_KEY) || "it");
  useEffect(() => { localStorage.setItem(STORAGE_KEY, lang); document.documentElement.lang = lang; }, [lang]);
  const t = useCallback((key) => (dict[lang] && dict[lang][key]) || (dict.it[key] || key), [lang]);
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}
export const useLang = () => useContext(LangContext) || { lang: "it", setLang: () => {}, t: (k) => dict.it[k] || k };
